// 请求异常处理函数
import router from '@/router/router'
import { removeCookie } from './cookies'

export default {
  handle50001() {
    removeCookie('token')
    router.replace({
      path: '/login',
      query: { redirect: router.currentRoute.fullPath }
    })
  }
}
